import { motion } from "framer-motion";
import logoWhite from "../assets/icono-blanco.svg";

export default function LoadingSpinner({ size = "normal" }: { size?: "small" | "normal" }) {
  // Determinar el tamaño basado en la prop
  const spinnerSize = size === "small" ? "w-16 h-16" : "w-24 h-24";
  const logoSize = size === "small" ? "w-10 h-10" : "w-16 h-16";
  const minHeight = size === "small" ? "min-h-[100px]" : "min-h-[200px]";

  return (
    <div className={`flex justify-center items-center ${minHeight}`}>
      <motion.div
        className={`relative ${spinnerSize}`}
        animate={{
          rotate: 360,
        }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: "linear",
        }}
      >
        {/* Círculo exterior */}
        <motion.div
          className="absolute inset-0 border-4 border-t-primary border-r-primary/20 border-b-primary/20 border-l-primary/20 rounded-full"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5 }}
        />

        {/* Logo central */}
        <motion.div
          className="absolute inset-0 flex items-center justify-center"
          initial={{ scale: 0.5, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          <img src={logoWhite} alt="InnoTec" className={logoSize} />
        </motion.div>
      </motion.div>
    </div>
  );
}
